export default {
  GroupActivityTrackerSelectAll: {
    mounted() {
      this.el.addEventListener('change', () => {
        const tableRowCheckboxes = this.el
          .closest('table')
          .querySelectorAll('.table-checkbox[id^=select-contact-checkbox-]');

        // Is checkbox being checked or unchecked?
        const checkedOrUnchecked = this.el.checked;

        tableRowCheckboxes.forEach((checkbox) => {
          // eslint-disable-next-line no-param-reassign
          checkbox.checked = checkedOrUnchecked;
        });

        // Inform server that all contact checkboxes have been checked or unchecked.
        this.pushEvent('select-all', { select_all: checkedOrUnchecked });
      });
    },
  },
};
